import { faEye } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import $ from "jquery";
import React, { useEffect, useState } from 'react';
import { Button, Col, Container, Form, Row, Tab, Table, Tabs } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import { useNavigate } from 'react-router-dom';
import AsyncSelect from 'react-select/async';
import * as Common from '../Common';
import Dialog from '../Dialog';
import DialogYesNo from '../Dialog_Yes_No';
import FaView from '../FaView';
import LoginHeader from '../Login_header';
import Menu from '../Menu';
import * as Picklist from '../Picklist';

function Tran_pp_adii() {


    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const startDate = sessionStorage.getItem('startDate');
    const endDate = sessionStorage.getItem('endDate');
    const branchDisable = sessionStorage.getItem('branchDisable');
    const [isTtSalesSettl, setIsTtSalesSettl] = useState("PURCHASE");
    console.log(isTtSalesSettl)
    const [key, setKey] = useState("INFO");
    const [settTabKey, setSettTabKey] = useState('PRODUCTDETAIL');
    // const [settkey, setSettKey] = useState("INFO");


    const [userRight, setUserRight] = useState([]);
    const [onceRun, setOnceRun] = useState(false);
    const [scrMode, setScrMode] = useState("");

    const [isMsgBoxYN, setMsgBoxYN] = useState(false);
    const [msgTextYN, setMsgTextYN] = useState("");
    const [isMsgBox, setMsgBox] = useState(false);
    const [msgText, setMsgText] = useState("");
    const [isErrBox, setErrBox] = useState(false);
    const [errText, setErrText] = useState("");

    const [dataList, setDataList] = useState([]);
    const [productDataPP, setProductDataPP] = useState([]);
    const [productDataES, setProductDataES] = useState([]);
    const [paymentData, setPaymentData] = useState([]);
    const [radioType, setRadioType] = useState("S");
    const [ttSettlementLocation, setTtSettlementLocation] = useState(null);
    const [locationCode, setLocationCode] = useState('0');
    const [location, setLocation] = useState("");
    const [ttFromSrno, setVtmFromSrno] = useState("");
    const [ttToSrno, setVtmToSrno] = useState("");
    const [vtmFromDate, setVtmFromDate] = useState(new Date());
    const [ttToDate, setVtmToDate] = useState(new Date());
    const [ledger, setLedger] = useState("");
    const [date, setDate] = useState(new Date());
    const [total, setTotal] = useState("");
    const [forexTotal, setForexTotal] = useState(0);
    const [totalAmount, setTotalAmount] = useState(0);
    const [faViewData, setFaViewData] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [hdrSrno, setHdrSrno] = useState(0);
    const [zeneRemitSrno, setZeneRemitSrno] = useState(0);
    const [hdrType, setHdrType] = useState("");
    const [hdrLocation, setHdrLocation] = useState("");

    const [showFaView, setShowFaView] = useState(false);
    const [faViewObject, setFaViewObject] = useState({ location: "", trannumber: "", type: "" });
    const [purSurrType, setPurSurrType] = useState("PP");


    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.getActiveBranch().then(response => {
                setTtSettlementLocation(response);
                response != null && handleChangeLocation(response);
            });
            Common.callApi(Common.apiRight, [sid, 'all', 'PURCHASE_ADII'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {
                    setUserRight(resp);
                } else {
                    navigate('/');
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);


    const handleChangeLocation = (value) => {
        setTtSettlementLocation(value);
        const loc = value.id.split('^');
        setLocationCode(loc[1]);
        setLocation(loc[2]);
        sessionStorage.activeBranch = loc[1];
        setDataList([])
    }


    const listData = () => {
        $(".loader").show();
        var msg = [], i = 0;
        if (ttSettlementLocation === null) {
            $(".loader").hide();
            setMsgText("Please Select Location!");
            setMsgBox(true);
        } else if ((radioType === 'S' && !ttFromSrno) || (radioType === 'S' && !ttToSrno) || (radioType === 'D' && !vtmFromDate) || (radioType === 'D' && !ttToDate)) {
            $(".loader").hide();
            msg[i++] = Common.getMessage("MSG0006");
            msg[i++] = (radioType === 'S' && !ttFromSrno ? " From." : '');
            msg[i++] = (radioType === 'S' && !ttToSrno ? " To." : '');
            msg[i++] = (radioType === 'D' && !vtmFromDate ? " From Date." : '');
            msg[i++] = (radioType === 'D' && !ttToDate ? " To Date." : '');
            setMsgText(Common.buildMessageFromArray(msg));
            setMsgBox(true);
        } else {
            const obj = {
                locationCode: locationCode,
                filterRadioType: radioType,
                filterFromSrno: ttFromSrno,
                filterToSrno: ttToSrno,
                filterFromDate: Common.dateYMD(vtmFromDate),
                filterToDate: Common.dateYMD(ttToDate),
                type: "PP",
                purSurrType: purSurrType,
            }
            Common.callApi(Common.apiPPAdii, [sid, 'list', JSON.stringify(obj)], (result) => {
                $(".loader").hide();
                let resp = JSON.parse(result);
                if (resp.status) {
                    setDataList(resp.list);
                } else {
                    setMsgBoxYN(true);
                    setScrMode(resp.msg);
                }
            });
        }
    }


    const cancelData = () => {
        setMsgBoxYN(false);
        setScrMode("");
    }


    function viewList(res) {
        $(".loader").show();
        setScrMode('Q');
        // setLocation(locationName);
        // setLedger(ledger);
        // setTotal(res.hdr_total);
        setDate(res.hdr_date);
        setHdrType(res.hdr_type);
        setHdrSrno(res.hdr_srno);
        setZeneRemitSrno(res.hdr_zeneremit_srno);
        setHdrLocation(res.hdr_location);
        setTotalAmount(Math.round(res.forex_amount))
        setForexTotal(Math.round(res.hdr_forex_total))
        if (purSurrType === 'PP') {
            setIsTtSalesSettl('PURCHASE');
        } else {
            setIsTtSalesSettl('SURRENDER');
        }
        setKey("INFO");
        setSettTabKey('PRODUCTDETAIL');
        const obj = {
            srno: res.hdr_srno,
            // line_no:res.
            location: res.hdr_location,
            type: 'ETT',
            trantype: res.hdr_type
        }
        Common.callApi(Common.apiPPAdii, [sid, 'view', JSON.stringify(obj)], (result) => {
            $(".loader").hide();
            let resp = JSON.parse(result);
            setProductDataPP(resp.productDataPP);
            setProductDataES(resp.productDataES);
            setPaymentData(resp.paymentData);
            // resp.paymentData.map(data=>)
            // setTotal(resp.paymentData[0].tp_amount);
        });
    }


    const handleFaView = (hdrSrno, hdrType) => {
        setShowFaView(true);
        setFaViewObject({ location: hdrLocation, trannumber: hdrSrno, type: hdrType });
    }

    function handlePrint() {
        $(".loader").show();
        const obj = {
            pType: 'ES',
            type: hdrType,
            location: hdrLocation,
            srno: hdrSrno,
            nCorporate: null,
            nDealer: null,
            printFlag: 'D'
        }
        Common.callApi(Common.apiPrint, [sid, 'print', JSON.stringify(obj)], (result) => {
            if (result) {
                $(".loader").hide();
                var newWindow = window.open();
                newWindow.document.write(result);
            }
        })
    }

    const handleTabChange = (k) => {
        setKey(k);
    }

    return (
        <>
            <LoginHeader />
            <Menu />
            <Container fluid>
                <Row>
                    <Col>
                        <h3>ADII</h3>
                    </Col>
                </Row>
                <Row>&nbsp;</Row>
                {
                    scrMode === "" ?
                        <>
                            <Row>
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Location<span className="colorThemeRed">*</span></Form.Label>
                                        <AsyncSelect
                                            cacheOptions={false}
                                            defaultOptions={false}
                                            value={ttSettlementLocation}
                                            getOptionLabel={e => e.label + ' '}
                                            getOptionValue={e => e.id}
                                            loadOptions={Picklist.fetchLocationAllowedPicklist}
                                            onInputChange={Picklist.handleInputChange}
                                            onChange={handleChangeLocation}
                                            isDisabled={branchDisable === "true"}
                                        >
                                        </AsyncSelect>
                                    </Form.Group>
                                </Col>
                                <Col className='col-md-4 col-6'>
                                    <Form.Group>
                                        <Row style={{ marginTop: "30px" }}>
                                            <Col>
                                                <Form.Check checked={radioType === "S"} onChange={() => setRadioType("S")} type='radio' label="SrNo" />
                                            </Col><Col>
                                                <Form.Check checked={radioType === "D"} onChange={() => setRadioType("D")} type='radio' label="Date" />
                                            </Col>
                                        </Row>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>
                                {
                                    radioType === 'S' ?
                                        <>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>From<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control value={ttFromSrno}
                                                        maxLength={20}
                                                        onChange={(e) => Common.validateNumValue(e.target.value, setVtmFromSrno)}
                                                        placeholder="From" />
                                                </Form.Group>
                                            </Col>
                                            <Col className='col-md-3 col-6'>
                                                <Form.Group>
                                                    <Form.Label>To<span className="text-danger">*</span></Form.Label>
                                                    <Form.Control value={ttToSrno}
                                                        maxLength={20}
                                                        onChange={(e) => Common.validateNumValue(e.target.value, setVtmToSrno)}
                                                        placeholder="To" />
                                                </Form.Group>
                                            </Col>

                                        </>
                                        :
                                        radioType === 'D' ?
                                            <>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>From<span className="colorThemeRed">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={vtmFromDate}
                                                            onChange={(date) => setVtmFromDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                                <Col className='col-md-3 col-6'>
                                                    <Form.Group>
                                                        <Form.Label>To<span className="colorThemeRed">*</span></Form.Label>
                                                        <DatePicker className="form-control"
                                                            selected={ttToDate}
                                                            onChange={(date) => setVtmToDate(date)}
                                                            dateFormat="dd/MM/yyyy"
                                                            showYearDropdown
                                                            showMonthDropdown
                                                            useShortMonthInDropdown
                                                            dropdownMode="select"
                                                            peekNextMonth
                                                            customInput={
                                                                <input type="text" size='sm' onKeyUp={(e) => Common.buildDateFormat(e.target.value, e.target)}></input>
                                                            }
                                                        />
                                                    </Form.Group>
                                                </Col>
                                            </>
                                            :
                                            null
                                }
                                <Col className='col-md-3 col-6'>
                                    <Form.Group>
                                        <Form.Label>Type</Form.Label>
                                        <Form.Select disabled={scrMode === "Q"} value={purSurrType} onChange={e => setPurSurrType(e.target.value)}>
                                            <option value="PP">Purchase</option>
                                            <option value="ES">Surrender</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    {
                                        userRight.query === "1" ?
                                            <Button variant='outline-primary' className='buttonStyle' size='sm' onClick={() => listData()}>List</Button>
                                            : null
                                    }
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>
                            <Row>
                                <Col>
                                    <Table striped bordered hover size="sm">
                                        <thead>
                                            <tr>
                                                {userRight.query === "1" ? <th></th> : null}
                                                <th>Type</th>
                                                <th>Sr No</th>
                                                <th>Location</th>
                                                <th>Ledger</th>
                                                <th>Date</th>
                                                <th>Amount</th>
                                                <th>Ref no</th>
                                                <th>Remitter Name</th>
                                                <th>Pan No</th>


                                            </tr>
                                        </thead>
                                        <tbody>
                                            {
                                                dataList.map((res, index) => (
                                                    <tr key={index}>
                                                        {userRight.query === "1" ?
                                                            <td className="textCenter">
                                                                <span className="handCursor colorThemeBlue" onClick={() => viewList(res)}>
                                                                    <FontAwesomeIcon icon={faEye} />
                                                                </span>
                                                            </td>
                                                            : null
                                                        }
                                                        <td>{res.hdr_type}</td>
                                                        <td>{res.hdr_srno}</td>
                                                        <td>{res.entity_name}</td>
                                                        <td>{res.ledger === "0 0 " ? '' : res.ledger}</td>
                                                        <td>{res.hdr_date}</td>
                                                        <td>{res.hdr_forex_total}</td>
                                                        <td>{res.hdr_refno}</td>
                                                        <td>{res.hdr_remittername}</td>
                                                        <td>{res.hdr_pan}</td>
                                                    </tr>
                                                ))
                                            }
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        </>
                        :
                        <>
                            <Row>
                                <Col>
                                    <Button variant='outline-danger' className='buttonStyle' size='sm' onClick={() => cancelData()}>Back</Button> {' '}
                                </Col>
                            </Row>
                            <Row>&nbsp;</Row>

                            <Tabs activeKey={isTtSalesSettl} defaultActiveKey="PURCHASE" onSelect={k => setIsTtSalesSettl(k)}>
                                {purSurrType === 'PP' ?
                                    <Tab eventKey="PURCHASE" title="Purchase">
                                        <Row>&nbsp;</Row>
                                        <Row>
                                            <Col>
                                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleFaView(hdrSrno, 'PP')}>FA View</Button>&nbsp;
                                                <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handlePrint()}>Print</Button>
                                            </Col>
                                        </Row>

                                        <Row>&nbsp;</Row>
                                        <Row>
                                            <Col >
                                                <Form.Label><b>Srno:</b> {hdrSrno}</Form.Label>
                                            </Col>
                                            <Col >
                                                <Form.Label><b>ZeneRemit Srno:</b> {zeneRemitSrno}</Form.Label>
                                            </Col>
                                            <Col >
                                                <Form.Label><b>Location:</b> {location}</Form.Label>
                                            </Col>
                                            <Col>
                                                <Form.Label><b>Date:</b> {date}</Form.Label>
                                            </Col>
                                            <Col >
                                                <Form.Label><b>Forex Amount: </b>{forexTotal}</Form.Label>
                                            </Col>
                                            <Col >
                                                <Form.Label><b>Total Amount:</b> {totalAmount}</Form.Label>
                                            </Col>
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        <Row>
                                            <Col style={{ justifyContent: 'space-evenly' }}>
                                                {/* <span> <b>GST : </b>{productDataPP[0]?.hdr_gst}</span> */}
                                                <span> <b>SGST : </b>{productDataPP[0]?.hdr_sgst}</span>
                                                <span> <b>IGST : </b>{productDataPP[0]?.hdr_igst}</span>
                                                <span> <b>CGST : </b>{productDataPP[0]?.hdr_cgst}</span>
                                                <span> <b>UGST : </b>{productDataPP[0]?.hdr_ugst}</span>
                                                <span> <b>TCS : </b>{productDataPP[0]?.hdr_tcs}</span>
                                                <span> <b>Round Off : </b>{productDataPP[0]?.hdr_roundoff}</span>
                                                <span> <b>Bank Charges : </b>{productDataPP[0]?.hdr_bankcharges}</span>
                                                <span><b>Nostro Charges : </b>{productDataPP[0]?.hdr_nostrocharges}</span>

                                                <br></br>
                                            </Col>
                                        </Row>
                                        <Row>&nbsp;</Row>
                                        <Tabs activeKey={key} defaultActiveKey="INFO" onSelect={k => handleTabChange(k)}>
                                            <Tab style={{ display: "none" }} eventKey="INFO" title="All Info">
                                                <Row>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Zenith Reference </Form.Label>
                                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                value={productDataPP[0]?.hdr_refno}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Zenith Reference </Form.Label>
                                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                value={productDataPP[0]?.hdr_ad2ref}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Individual </Form.Label>
                                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                value={productDataPP[0]?.individual_name}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Individual Id </Form.Label>
                                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                value={productDataPP[0]?.indi_idtype_num}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Executive </Form.Label>
                                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                value={productDataPP[0]?.executive_name}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>IBan Number </Form.Label>
                                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                value={productDataPP[0]?.hdr_iban_no}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Pan Number </Form.Label>
                                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                value={productDataPP[0]?.hdr_pan}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Name On Pan </Form.Label>
                                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                value={productDataPP[0]?.hdr_nameonpan}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Nostro Type </Form.Label>
                                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                value={productDataPP[0]?.hdr_nostrotype}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Pan Relation </Form.Label>
                                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                value={productDataPP[0]?.hdr_pan_relation}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Purpose </Form.Label>
                                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                value={productDataPP[0]?.purpose_name}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    {/* <Col className="col-md-3 col-6">
                                            <Form.Group>
                                                <Form.Label>Remitter Name : {productDataPP[0]?.hdr_remittername}</Form.Label>
                                            </Form.Group>
                                        </Col> */}
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Place of Supply </Form.Label>
                                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                value={productDataPP[0]?.hdr_supply_place}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Source Of Fund </Form.Label>
                                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                value={productDataPP[0]?.hdr_sourceoffund === 'L' ? 'Loan' : 'Other'}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        <Form.Group>
                                                            <Form.Label>Product Type </Form.Label>
                                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                value={productDataPP[0]?.prd_product}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col className="col-md-3 col-6">
                                                        {/* <Form.Group>
                                                        <Form.Label>Issuer Comment : {productDataPP[0]?.hdr_issuercomment}</Form.Label>
                                                    </Form.Group> */}
                                                        {/* <Col>
                                                        Issuer Comment : <b>{reqHeader.reqi_issuercomment}</b>
                                                    </Col> */}
                                                    </Col>
                                                    <Col xs={12} >
                                                        <Form.Group >
                                                            <Form.Label>Issuer Comment  </Form.Label>
                                                            <Form.Control as="textarea" rows={5} placeholder="Issuer Comment" maxLength={1000} autoComplete="off"
                                                                value={productDataPP[0]?.hdr_issuercomment}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={12} >
                                                        <Form.Group >
                                                            <Form.Label>Subject Line: {productDataPP[0]?.hdr_inward_subjectline}</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={productDataPP[0]?.hdr_inward_subjectline}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col xs={6} >
                                                        <Form.Group >
                                                            <Form.Label>Confirmation Statement : {productDataPP[0]?.hdr_branchconfirmremark}</Form.Label>
                                                            <Form.Control
                                                                type="text"
                                                                value={productDataPP[0]?.hdr_branchconfirmremark}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>

                                                </Row>
                                                <Row>&nbsp;</Row>
                                                <Row>
                                                    <Col xs={6} >
                                                        <Form.Group >
                                                            <Form.Label>Client Name : </Form.Label>
                                                            <Form.Control type="text" placeholder="Account Number" maxLength={50} autoComplete="off"
                                                                value={productDataPP[0]?.hdr_remittername}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col>
                                                        <Form.Group>
                                                            <Form.Label>Client Bank Account Number</Form.Label>
                                                            <Form.Control type="text" placeholder="Account Number" maxLength={50} autoComplete="off"
                                                                value={productDataPP[0]?.hdr_remitteracctno}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                    <Col>
                                                        <Form.Group>
                                                            <Form.Label>Client Bank IFSC </Form.Label>
                                                            <Form.Control type="text" placeholder="IFSC" maxLength={11} autoComplete="off"
                                                                value={productDataPP[0]?.hdr_remitteracctifsc}
                                                                disabled
                                                            />
                                                        </Form.Group>
                                                    </Col>
                                                </Row>
                                                {/* <Row>
                                                <Col>
                                                    <h4>Remmiter Details</h4>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col>
                                                    <Table striped bordered hover size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Name</th>
                                                                <th>Date Of Birth</th>
                                                                <th>Id Type</th>
                                                                <th>Id No </th>
                                                                <th>Type</th>
                                                                <th>Address</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            <tr key={0}>
                                                                <td>{productDataPP[0]?.hdr_remittername}</td>
                                                                <td>{Common.dateDMYStr(productDataPP[0]?.hdr_remitterdob)}</td>
                                                                <td>{productDataPP[0]?.remitteriddesc}</td>
                                                                <td>{productDataPP[0]?.hdr_remitteridno}</td>
                                                                <td>{productDataPP[0]?.hdr_remittertype === 'I' ? 'Individual' : productDataPP[0]?.hdr_remittertype}</td>
                                                                <td>{productDataPP[0]?.hdr_remitteraddress}</td>

                                                            </tr>

                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row> */}

                                            </Tab>
                                            <Tab eventKey="BENE" title="Beneficiary Details">
                                                <Row>
                                                    <Col>
                                                        <h4>Beneficiary Details</h4>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Table striped bordered hover size="sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>Name</th>
                                                                    <th>Account Number</th>
                                                                    <th>Bank</th>
                                                                    <th>Swift Code</th>
                                                                    <th>Type</th>
                                                                    <th>Address</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr key={0}>
                                                                    <td>{productDataPP[0]?.hdr_benename}</td>
                                                                    <td>{productDataPP[0]?.hdr_benebankacct}</td>
                                                                    <td>{productDataPP[0]?.hdr_benebank}</td>
                                                                    <td>{productDataPP[0]?.hdr_beneswiftcode}</td>
                                                                    <td>{productDataPP[0]?.hdr_bene_type}</td>
                                                                    <td>{productDataPP[0]?.hdr_beneadd}</td>
                                                                </tr>

                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                                {productDataPP[0]?.hdr_sourceoffund === 'L' && <>
                                                    <Row>
                                                        <Col>
                                                            <h4>Loan Details</h4>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Table striped bordered hover size="sm">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Account Number</th>
                                                                        <th>Name</th>
                                                                        <th>Pan</th>
                                                                        <th>Passport</th>
                                                                        <th>Co Applicant Name</th>
                                                                        <th>Co Applicant Pan</th>
                                                                        <th>Co Applicant Passport</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    <tr key={0}>
                                                                        <td>{productDataPP[0]?.hdr_loanaccountno}</td>
                                                                        <td>{productDataPP[0]?.hdr_loanapplicant}</td>
                                                                        <td>{productDataPP[0]?.hdr_loanapplicantpan}</td>
                                                                        <td>{productDataPP[0]?.hdr_loanapplicantpassport}</td>
                                                                        <td>{productDataPP[0]?.hdr_loancoapplicant}</td>
                                                                        <td>{productDataPP[0]?.hdr_loancoapplicantpan}</td>
                                                                        <td>{productDataPP[0]?.hdr_loancoapplicantpassport}</td>
                                                                    </tr>

                                                                </tbody>
                                                            </Table>
                                                        </Col>
                                                    </Row>
                                                </>}
                                            </Tab>
                                            <Tab eventKey="PRODUCTDETAILS" title="Product Details">
                                                <Row>
                                                    <Col>
                                                        <h4>Product Info</h4>
                                                    </Col>
                                                </Row>
                                                <Row>
                                                    <Col>
                                                        <Table striped bordered hover size="sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>Location</th>
                                                                    <th>ISD</th>
                                                                    <th>Issuer Ledger</th>
                                                                    <th>Date</th>
                                                                    <th>Product</th>
                                                                    <th>Denomination</th>
                                                                    <th>Quantity</th>
                                                                    <th>Rate</th>
                                                                    <th>Amount</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    productDataPP.map((res, index) => (
                                                                        <tr key={index}>
                                                                            <td>{res.entity_name}</td>
                                                                            <td>{res.isd}</td>
                                                                            <td>{res.ledger === "0 0 " ? '' : res.ledger}</td>
                                                                            <td>{res.prd_date}</td>
                                                                            <td>{res.prd_product}</td>
                                                                            <td>{res.prd_deno}</td>
                                                                            <td>{res.prd_qty}</td>
                                                                            <td>{res.prd_rate}</td>
                                                                            <td>{res.prd_amount}</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                                <Row>&nbsp;</Row>
                                            </Tab>
                                            <Tab eventKey="PAYMENTDETAILS" title="Payment Details">
                                                <Row>
                                                    <Col>
                                                        <Table striped bordered hover size="sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>Location</th>
                                                                    <th>Ledger</th>
                                                                    <th>Payment Type</th>
                                                                    <th>Amount</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    paymentData.map((res) => (
                                                                        (res.tp_type === 'PP' && <tr key={res.tp_line_no}>
                                                                            <td>{res.entity_name}</td>
                                                                            {/* <td>{res.ledger}</td> */}
                                                                            <td>{res.ledger === "0 0 " ? '' : res.ledger}</td>
                                                                            <td>{res.tp_payment_type === "RC" ? "Receivables" :
                                                                                res.tp_payment_type === "PB" ? "Payables" :
                                                                                    res.tp_payment_type === "BN" ? "Bank" : res.tp_payment_type}
                                                                            </td>
                                                                            <td>{res.tp_amount}</td>
                                                                        </tr>)
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                            </Tab>
                                            <Tab eventKey="COMMISSIONDETAILS" title="Commission Details">
                                                <Row>
                                                    <Col>
                                                        <Table striped bordered hover size="sm">
                                                            <thead>
                                                                <tr>
                                                                    <th>Commission Type</th>
                                                                    <th>Commission Value</th>
                                                                    <th>Commission </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    productDataPP.map((res, num) => (
                                                                        <tr key={num}>
                                                                            <td>{res.prd_commission_type === 'F' ? 'FLAT' :
                                                                                res.prd_commission_type === 'R' ? 'PERCANTAGE' :
                                                                                    res.prd_commission_type === 'P' ? 'PAISA' :
                                                                                        res.prd_commission_type}</td>
                                                                            <td>{res.prd_commission_value}</td>
                                                                            <td>{res.prd_commission}</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </Table>
                                                    </Col>
                                                </Row>
                                            </Tab>
                                            <Row>
                                                <Col>
                                                    <Table striped bordered hover size="sm">
                                                        <thead>
                                                            <tr>
                                                                <th>Location</th>
                                                                <th>Ledger</th>
                                                                <th>Payment Type</th>
                                                                <th>Amount</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                paymentData.map((res) => (
                                                                    <tr key={res.tp_line_no}>
                                                                        <td>{res.entity_name}</td>
                                                                        {/* <td>{res.ledger}</td> */}
                                                                        <td>{res.ledger === "0 0 " ? '' : res.ledger}</td>
                                                                        <td>{res.tp_payment_type === "RC" ? "Receivables" :
                                                                            res.tp_payment_type === "PB" ? "Payables" :
                                                                                res.tp_payment_type === "BN" ? "Bank" : res.tp_payment_type}
                                                                        </td>
                                                                        <td>{res.tp_amount}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </Table>
                                                </Col>
                                            </Row>
                                        </Tabs>
                                    </Tab>
                                    : purSurrType === 'ES' ?
                                        <Tab eventKey="SURRENDER" title="Surrender">
                                            <Row>&nbsp;</Row>
                                            <Row>
                                                <Col>
                                                    <Button variant='outline-success' className='buttonStyle' size='sm' onClick={() => handleFaView(productDataES[0]?.settsrno, 'ES')}>FA View</Button>
                                                </Col>
                                            </Row>
                                            <Row>&nbsp;</Row>
                                            <Row>
                                                <Col >
                                                    <Form.Label><b>Srno:</b> {productDataES[0]?.settsrno}</Form.Label>
                                                </Col>
                                                <Col >
                                                    <Form.Label><b>Location:</b> {location}</Form.Label>
                                                </Col>
                                                <Col>
                                                    <Form.Label><b>Date:</b> {date}</Form.Label>
                                                </Col>
                                                <Col >
                                                    <Form.Label><b>Forex Amount: </b>{forexTotal}</Form.Label>
                                                </Col>
                                                <Col >
                                                    <Form.Label><b>Total Amount:</b> {totalAmount}</Form.Label>
                                                </Col>
                                            </Row>
                                            <Row>&nbsp;</Row>
                                            <Row>
                                                <Col style={{ justifyContent: 'space-evenly' }}>
                                                    <span> <b>GST : </b>{productDataPP[0]?.hdr_gst}</span>
                                                    <span> <b>SGST : </b>{productDataPP[0]?.hdr_sgst}</span>
                                                    <span> <b>IGST : </b>{productDataPP[0]?.hdr_igst}</span>
                                                    <span> <b>CGST : </b>{productDataPP[0]?.hdr_cgst}</span>
                                                    <span> <b>UGST : </b>{productDataPP[0]?.hdr_ugst}</span>
                                                    <span> <b>TCS : </b>{productDataPP[0]?.hdr_tcs}</span>
                                                    <span> <b>Round Off : </b>{productDataPP[0]?.hdr_roundoff}</span>
                                                    <span> <b>Bank Charges : </b>{productDataPP[0]?.hdr_bankcharges}</span>
                                                    <span><b>Nostro Charges : </b>{productDataPP[0]?.hdr_nostrocharges}</span>

                                                    <br></br>
                                                </Col>
                                            </Row>
                                            <Row>&nbsp;</Row>
                                            <Tabs activeKey={settTabKey} defaultActiveKey="PRODUCTDETAIL" onSelect={k => setSettTabKey(k)}>
                                                <Tab eventKey="PRODUCTDETAIL" title="Product Details">
                                                    <Row>
                                                        <Col>
                                                            <h4>Product Info</h4>
                                                        </Col>
                                                    </Row>
                                                    <Row>
                                                        <Col>
                                                            <Table striped bordered hover size="sm">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Location</th>
                                                                        <th>ISD</th>
                                                                        <th>Ledger</th>
                                                                        <th>Date</th>
                                                                        <th>Product</th>
                                                                        <th>Denomination</th>
                                                                        <th>Quantity</th>
                                                                        <th>Rate</th>
                                                                        <th>Amount</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        productDataES.map((res, index) => (
                                                                            <tr key={index}>
                                                                                <td>{res.settlocation}</td>
                                                                                <td>{res.settisd}</td>
                                                                                {/* <td>{res.settledger}</td> */}
                                                                                <td>{res.settledger === "0 0 " ? '' : res.settledger}</td>
                                                                                <td>{res.settdate}</td>
                                                                                <td>{res.settproduct}</td>
                                                                                <td>{res.settdeno}</td>
                                                                                <td>{res.settqty}</td>
                                                                                <td>{res.settrate}</td>
                                                                                <td>{res.settamount}</td>
                                                                            </tr>
                                                                        ))
                                                                    }
                                                                </tbody>
                                                            </Table>
                                                        </Col>
                                                    </Row>
                                                    <Row>&nbsp;</Row>
                                                </Tab>
                                                <Tab eventKey="PAYMENTDETAILS" title="Payment Details">
                                                    <Row>
                                                        <Col>
                                                            <Table striped bordered hover size="sm">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Location</th>
                                                                        <th>Ledger</th>
                                                                        <th>Payment Type</th>
                                                                        <th>Amount</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        paymentData.map((res) => (
                                                                            (res.tp_type === 'ES' &&
                                                                                <tr key={res.tp_line_no}>
                                                                                    <td>{res.entity_name}</td>
                                                                                    {/* <td>{res.ledger}</td> */}
                                                                                    <td>{res.ledger === "0 0 " ? '' : res.ledger}</td>
                                                                                    <td>{res.tp_payment_type === "RC" ? "Receivables" :
                                                                                        res.tp_payment_type === "PB" ? "Payables" :
                                                                                            res.tp_payment_type === "BN" ? "Bank" : res.tp_payment_type}
                                                                                    </td>
                                                                                    <td>{res.tp_amount}</td>
                                                                                </tr>
                                                                            )
                                                                        ))
                                                                    }
                                                                </tbody>
                                                            </Table>
                                                        </Col>
                                                    </Row>
                                                </Tab>
                                            </Tabs >
                                        </Tab> : null}
                            </Tabs >

                        </>
                }
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
                <Row>&nbsp;</Row>
            </Container >
            <div>
                <Dialog isOpen={isMsgBox} onClose={(e) => setMsgBox(false)}>
                    {msgText}
                </Dialog>
                <DialogYesNo isOpen={isMsgBoxYN} onYes={(e) => cancelData()} onNo={(e) => setMsgBoxYN(false)}>
                    {msgTextYN}
                </DialogYesNo>
                <Dialog isOpen={isErrBox} onClose={(e) => setErrBox(false)}>
                    {errText}
                </Dialog>
            </div>
            <FaView faViewObject={faViewObject} show={showFaView} onHide={() => setShowFaView(false)} />
        </>
    )
}

export default Tran_pp_adii
